import {
  SET_STORAGE_SETTINGS,
} from '../actions/types';

export default (state = {}, action) => {
  switch (action.type) {
    case SET_STORAGE_SETTINGS:
      return action.payload;
    default:
      return state;
  }
};
